import { mock, instance, verify, when, anyNumber, anything, resetCalls } from 'ts-mockito';
import { Router } from 'aurelia-router';
import { Customer } from '../../models/customer';
import { State } from '../../services/global-state';
import { PayrazrService } from '../../services/payrazr';
import { Business } from '../../models/business';
import { Features } from '../../models/features';
import { I18N } from 'aurelia-i18n';
import { Preferences, Model } from './preferences';

describe('NewPortalWeb', () => {
	describe('pages', () => {
		describe('add-payment-method', () => {
			let component: Preferences;
			const mockRouter: Router = mock(Router);
			const mockState: State = mock(State);
			const mockCustomer: Customer = mock(Customer);
			const mockBusiness: Business = mock(Business);
			const mockPayrazrService: PayrazrService = mock(PayrazrService);
			const mockI18N: I18N = mock(I18N);

			// Mock I18N Dependencies
			beforeEach(() => {
				const i18next = {
					t: (a, b) => a
				};
				when(mockI18N.i18next).thenReturn(i18next);
				spyOn(i18next, 't').and.returnValue('localized');
			});

			// Initialize Component
			beforeEach(() => {
				const features = new Features({});
				when(mockState.features).thenReturn(features);
				when(mockState.business).thenReturn(instance(mockBusiness));
				when(mockBusiness.portalSettings).thenReturn({
					businessSettings: {
						isInvoiceEnabled: true,
						enableSMS: true
					}
				});
				when(mockState.customer).thenReturn(instance(mockCustomer));
				component = new Preferences(
					instance(mockRouter),
					instance(mockPayrazrService),
					instance(mockState),
					instance(mockI18N)
				);
			});

			it('should initialize component', () => {
				expect(component).toBeTruthy();
			});

			describe('activate()', () => {
				it('should setup data', async () => {
					when(mockPayrazrService.refreshGlobalCustomer()).thenResolve();
					when(mockCustomer.notificationSettings).thenReturn({
						smsIsOptedIn: true,
						smsIsValidated: true,
						isEmailOptedIn: true
					});
					when(mockCustomer.securitySettings).thenReturn({
						username: 'test',
						question1: 'testq1',
						question2: 'testq2'
					});
					when(mockCustomer.documentSettings).thenReturn({
						isPaperOptedIn: true,
						isEmailOptedIn: true
					});
					await component.activate();
					expect(component.isSmsOptedIn).toBeTruthy();
					expect(component.smsRequiresVerification).toBeFalsy();
					expect(component.isSMSEnabled).toBeTruthy();
				});
			});

			describe('updateContactInformation()', () => {
				it('should handle success', async () => {
					when(mockPayrazrService.updateContactInformation(anything())).thenResolve({
						isSuccessful: true,
						entity: {}
					});
					const model = new Model({
						securitySettings: {
							username: 'testName',
							question1: 'q1',
							question2: 'q2'
						},
						notificationSettings: {
							isEmailOptedIn: true
						},
						documentSettings: {
							isPaperOptedIn: true,
							isEmailOptedIn: true
						},
						email: 'test@test.com',
						homePhone: '1234567890',
						mobilePhone: '1234567890'
					});
					component.model = model;
					await component.updateContactInformation();
					expect(component.validationErrors.length).toEqual(0);
					expect(component.smsRequiresVerification).toBeTruthy();
				});
			});

		});
	});
});
